<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title> {{$t('POS-Cost-Report')}} </v-toolbar-title>

              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"  :label="this.$t('Search')">

              </v-text-field>

<v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}

</v-btn>

              <v-menu bottom="" left>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>



          <v-container fluid>

            <v-layout row wrap>





              <v-flex xs12 sm2 md2 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplam.ToplamPuan}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{ $t('Total-Score') }} </span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm2 md2 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplam.ToplamPosMaliyet | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{$t('Total-POS-Cost')}}</span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm2 md2 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplam.ToplamVadeFark | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold">{{ $t('Total-Delay-Interest') }}</span>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm2 md2 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplam.ToplamTutar | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{$t('totalnumber')}}</span>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm4 md4 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplam.ToplamKazanc | moneyformat }}{{getparabirimi()}}



                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{ $t('Total-Gain') }}</span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>











            </v-layout>

          </v-container>

          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>

                  <v-card flat>

                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>

                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"

                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>

                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>

                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"

                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>

                      </v-flex>

                      <v-flex pt-2>

                        <v-layout align-center="">

                          <div v-if="load1">

                            <v-btn color="info" @click="getList()" fab small="" dark>

                              <v-icon>search</v-icon>

                            </v-btn>

                          </div>

                          <div v-if="progress">

                            <v-layout align-center="">

                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                            </v-layout>

                          </div>

                          <v-badge color="white" :overlap="true">

                            <template v-slot:badge>

                              <v-icon v-if="filtrevarmi" large color="green">

                                check_circle_outline </v-icon>

                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                              @click="filtrele()" color="info" fab dark>

                              <v-icon>filter_list</v-icon>

                            </v-btn>

                            <v-tooltip bottom="" :activator="el" v-model="tooltip">

                              <span>{{$t('Add-Search-Filter')}}</span>

                            </v-tooltip>





                          </v-badge>

                        </v-layout>

                      </v-flex>

                    </v-layout>

                  </v-card>

                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>

                  <v-card flat class="white--text">

                    <v-card flat="">

                      <v-card-actions>

                        <v-layout row wrap>

                          <!-- <v-flex xs12 sm12 md12>

                            <v-toolbar flat="" size="120px" dark color="#66BB6A">

                              <v-toolbar-title> <span class="subheading white--text">

                                  BSFormu

                                </span> </v-toolbar-title>

                              <v-spacer></v-spacer>

                              <v-flex xs6 sm6 md6>

                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"  :label="this.$t('Search')"

                                  append-icon="search"></v-text-field>

                              </v-flex>

                            </v-toolbar>

                          </v-flex> -->







                          <v-flex xs12 md12 sm12>

                            <v-card flat>

                              <div class="posmaliyet-report-table">
                              <ReportTable
                                :headers="headersbs"
                                :items="itemsbs"
                                storage-key="posmaliyetraporu_columns"
                                :loading="progress"
                                :has-searched="itemsbs && itemsbs.length > 0"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('POS-Cost-Report')"
                                :export-meta-items="posMaliyetExportMetaItems"
                                :export-summary-cards="posMaliyetSummaryCards"
                                :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                              ></ReportTable>
                            </div>

                            </v-card>

                          </v-flex>







                        </v-layout>

                      </v-card-actions>

                    </v-card>

                  </v-card>

                </v-flex>



              </v-layout>

            </v-form>

          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

          </v-snackbar>





          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">

            <v-card color="grey lighten-5">

              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

              <v-divider></v-divider>

              <v-card-text>

                <v-layout row="" wrap="">



                  <v-flex xs12 sm12 md12 pa-1>

                    <v-card class="white--text">

                      <v-card color="grey lighten-5" flat="">

                        <v-card-actions>

                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>

                              <v-autocomplete hide-details tabindex="1" :label="$t('Select-Bank')" :items="bankaitems"

                                clearable="" item-text="BankaAdi" cache-items="" item-value="BankaKod"

                                v-model="Rapor.BankaKod"></v-autocomplete>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-autocomplete hide-details tabindex="1" :label="$t('Select-Quota-Code')" :items="kotaitems"

                                clearable="" cache-items="" v-model="Rapor.Kotakod"></v-autocomplete>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="Rapor.VadeTarih" :label="$t('Maturity-Date')" hide-details=""></v-checkbox>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="Rapor.OzetRapor" :label="$t('Summary-Report')" hide-details=""></v-checkbox>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="Rapor.TaksitToplamRapor" :label="$t('Report-with-Instalment-Total')"

                                hide-details=""></v-checkbox>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                            </v-flex>

                          </v-layout>

                        </v-card-actions>

                      </v-card>

                    </v-card>

                  </v-flex>

                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

              </v-card-actions>

            </v-card>

          </v-dialog>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>



<script>

  import auth from '../../../api/auth'

  import tarihcomp from '../customcomp/tarihim'

  import helpers from "@/components/app/customcomp/helpers.js"

  import parainput from "@/components/app/customcomp/parainput.vue"

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"



  export default {

    data() {

      return {

        mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "Pos Maliyet Raporu - POS Cost Report",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || 'Zorunlu alan',

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

},

        PB:'TRY',

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi: false,

        kotaitems: [],

        bankaitems: [],

        genelToplam: {

          ToplamKazanc: 0,

          ToplamPosMaliyet: 0,

          ToplamPuan: 0,

          ToplamTutar: 0,

          ToplamVadeFark: 0

        },

        ToplamAdet: 0,

        GenelDipToplam: 0,

        search: '',

        searchsatilanbilet: null,

        searchiadebilet: null,

        searchvoid: null,
        headersbs: [{
            text: this.$t('Bank'),
            value: 'BankaKod',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '140px'
          },
          {
            text: this.$t('Bank-Name'),
            value: 'BankaAdi',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '240px'
          },
          {
            text: this.$t('Quota'),
            value: 'KotaKod',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '140px'
          },
          {
            text: this.$t('Date'),
            value: 'Tarih',
            visible: true,
            sortable: true,
            type: 'date',
            align: 'left',
            width: '140px'
          },
          {
            text: this.$t('Maturity'),
            value: 'Vade',
            visible: true,
            sortable: true,
            type: 'date',
            align: 'left',
            width: '140px'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '150px'
          },
          {
            text: this.$t('Point'),
            value: 'Puan',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'right',
            width: '120px'
          },
          {
            text: this.$t('Delay-interest'),
            value: 'VadeFark',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '160px'
          },
          {
            text: this.$t('POS-Cost'),
            value: 'PosMaliyet',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '160px'
          },
          {
            text: this.$t('Earning'),
            value: 'Kazanc',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '160px'
          },
          {
            text: this.$t('Instalment'),
            value: 'Taksit',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'center',
            width: '120px'
          }
        ],

        Rapor: {

          SirketKodu: null,

          BaslangicTarih: null,

          BitisTarih: null,

          BankaKod: null,

          Kotakod: null,

          VadeTarih: false,

          OzetRapor: false,

          TaksitToplamRapor: false,

        },

        hesapgurubu: [],

        masrafmerkezi: [],

        doviztipi: [],

        valid: true,

        tumsirketler: '',

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        kredikarti: [],

        statecari: [],

        searchcari: '',

        progress: false,

        tooltip: false,

        el: null,

        yok: false,

        itemsbs: [],





        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        dictionary: {

          custom: {

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    mounted() {

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi

        this.$http.post(auth.API_URL + 'api/Definitions/QuotaList', null, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.kotaitems = response.body

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable-QuotaList'

            this.snackbar = true

          } else {

            this.text1 = 'Service Unavailable-QuotaList'

            this.snackbar = true

          }

        })

        var params = {

          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/Bank/List', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.bankaitems = response.body

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable-Bank/List'

            this.snackbar = true

          } else {

            this.text1 = 'Service Unavailable-Bank/List'

            this.snackbar = true

          }

        })



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              var url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              var url = '#/'

              window.open(url, '_self')

            }

          } else {

          }

        });

      }

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      }

    },

    components: {

      'tarihcomp': tarihcomp,

      parainput,

      havayollaricomp,

      yetkidialog,
      ReportTable

    },


    computed: {
      posMaliyetExportMetaItems() {
        return [
          { label: this.$t('Starting-Date'), value: this.Rapor ? this.Rapor.BaslangicTarih : '', type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.Rapor ? this.Rapor.BitisTarih : '', type: 'date' },
          { label: this.$t('Select-Bank'), value: this.Rapor ? this.Rapor.BankaKod : '' },
          { label: this.$t('Select-Quota-Code'), value: this.Rapor ? this.Rapor.Kotakod : '' },
          { label: this.$t('Maturity-Date'), value: this.Rapor && this.Rapor.VadeTarih ? 'Evet' : 'Hayır' },
          { label: this.$t('Summary-Report'), value: this.Rapor && this.Rapor.OzetRapor ? 'Evet' : 'Hayır' },
          { label: this.$t('Report-with-Instalment-Total'), value: this.Rapor && this.Rapor.TaksitToplamRapor ? 'Evet' : 'Hayır' },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? 'Evet' : 'Hayır' }
        ]
      },

      posMaliyetSummaryCards() {
        return [
          {
            title: this.$t('POS-Cost-Report'),
            items: [
              { label: this.$t('Total-Score'), value: this.genelToplam ? this.genelToplam.ToplamPuan : 0 },
              { label: this.$t('Total-POS-Cost'), value: this.genelToplam ? this.genelToplam.ToplamPosMaliyet : 0, type: 'money' },
              { label: this.$t('Total-Delay-Interest'), value: this.genelToplam ? this.genelToplam.ToplamVadeFark : 0, type: 'money' },
              { label: this.$t('totalnumber'), value: this.genelToplam ? this.genelToplam.ToplamTutar : 0, type: 'money' },
              { label: this.$t('Total-Gain'), value: this.genelToplam ? this.genelToplam.ToplamKazanc : 0, type: 'money' }
            ]
          }
        ]
      }
    },

    watch: {

    },

    methods: {

  getparabirimi() {

    return helpers.getparabirimi();

  },

  openMailDialog() {

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = "Pos Maliyet Raporu - POS Cost Report";

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;

    if (!(this.$refs && this.$refs.formgunluksatis && this.$refs.formgunluksatis.validate && this.$refs.formgunluksatis.validate())) return;

    const credsRaw = window.localStorage.getItem('credentials');

    const creds = credsRaw ? JSON.parse(credsRaw) : {};

    const companyCode = this.tumsirketler === true ? '0' : (creds && creds.SirketKodu ? creds.SirketKodu : null);

    const R = JSON.parse(JSON.stringify(this.Rapor || {}));

    R.SirketKodu = companyCode;

    const mp = this.mailPayload || {};

    const payload = {

      Input: R,

      Mail: {

        To: mp.To || "",

        AgencyName: mp.AgencyName || "",

        DocType: mp.DocType || "Pos Maliyet Raporu - POS Cost Report",

        AgentFullName: mp.AgentFullName || "",

        CustomBody: mp.CustomBody || ""

      }

    };

    this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/Report/MailGonderPosCostReportxcel';

    this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })

      .then(() => {

        this.mailLoading = false;

        this.mailDialog = false;

        this.text1 = this.$t ? this.$t('Email-sent') : 'Mail gönderildi.';

        this.snackbar = true;

      }, (err) => {

        this.mailLoading = false;

        const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

        const msg = (body && (body.Message || body.message)) || err.statusText || (this.$t ? this.$t('Email-send-failed') : 'Mail gönderilemedi.');

        this.text1 = msg;

        this.snackbar = true;

      });

  },

  git(v) {

    var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri.BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi;

    window.open(url, '_blank');

  },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal

    }

  }



  function filtrele() {

    this.dialogfiltre = true

  }





  function filtrekayit() {

    this.dialogfiltre = false

    this.filtrevarmi = true

    this.getList();

  }

  function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.tumsirketler = false

    this.Rapor.BankaKod = null

    this.Rapor.Kotakod = null

    this.Rapor.VadeTarih = false

    this.Rapor.OzetRapor = false

    this.Rapor.TaksitToplamRapor = false

  }



  function getList() {

    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Report/PosCostReport', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.itemsbs = response.body.DetayList

          this.genelToplam = response.body

          this.progress = false

          this.load1 = true

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }





  function getListHtml() {



    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var lang = localStorage.getItem('lang')

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Report/PosCostReportHtml", params, {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader()

          }

        }).then((response) => {

          if (lang=='en')

          {

            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> POS MALİYET RAPORU </title>','<title> POS COST </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>POS MALİYET RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>POS COST</font>")

             bodyhtml=bodyhtml.toString().replace("Banka Code :","Bank Code :")

             bodyhtml=bodyhtml.toString().replace("Pos Maliyet","Pos Cost")

             bodyhtml=bodyhtml.toString().replace("Vade Farkı","Maturity Difference")

             bodyhtml=bodyhtml.toString().replace("Kazanç","Profit")

             bodyhtml=bodyhtml.toString().replace("Taksit","Installment")

             bodyhtml=bodyhtml.toString().replace("Banka","Bank")

             bodyhtml=bodyhtml.toString().replace("TOPLAM :","TOTAL :")

             response.bodyText=bodyhtml;

          }

          this.progress = false

          this.load1 = true

          var blob = new Blob([response.bodyText], {

            type: 'application/html'

          });

          var link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('PosMaliyet') + ".html";

          link.click();





        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }



  function getListExcel() {



    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Report/PosCostReportExcel", params, {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader()

          },

          responseType: "arraybuffer"

        }).then((response) => {

          this.progress = false

          this.load1 = true

          var blob = new Blob([response.data], {

            type: 'application/xlsx'

          });

          var link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('PosMaliyet') + ".xlsx";;

          link.click();



        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }

  function beforeMount() {

  }

</script>

<style scoped>

/* Bu stiller yalnızca posmaliyetraporu.vue sayfasına özeldir. */
.posmaliyet-report-table {
  width: 100%;
  margin-top: 4px;
}

.posmaliyet-report-table > * {
  width: 100%;
}

</style>
